import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-productspricecontrol',
  templateUrl: './productspricecontrol.component.html',
  styleUrls: ['./productspricecontrol.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProductspricecontrolComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      // Debounce search.
      this.configSearchTermUpdate.pipe(
        debounceTime(500),
        distinctUntilChanged())
        .subscribe(value => {
  
          if(value?.length >= 1){
            this.ConfigurationTerm = value;
            this.GetImportConfigurations();
          }
        });

         // Debounce search.
    this.productsSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
       this.Filter.SearchTerm = value;
       this.ResetPager();
       this.GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);
      });

        // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value, 1);
        }
      });

      // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.PartnersFilter.SearchTerm = value;
          this.PartnerSearchTerm = value;
          this.GetPartnersFiltered();
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  configSearchTermUpdate = new Subject<string>();
  groupSearchTermUpdate = new Subject<string>();
  partnerSearchTermUpdate = new Subject<string>();
  productsSearchTermUpdate = new Subject<string>();

  SearchTerm:string;
  Partners:[];
  PartnersCount:number;
  Partner: {[k: string]: any} = {};
  Filter: {[k: string]: any} = {};
  PartnersFilter: {[k: string]: any} = {};
  ShowFilter:boolean;
  PartnerSearchTerm:string;

  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  Countries:any[];
  Companies:any[];
  Banks:any[];
  AuxBanks:any[];
  CurrentBank:any;
  CurrentShippingAddress:any;
  ProfitSettingsPercentageImpacts:any[];
  Currencies:any[];
  DecimalPrecisions:any[];

  ShowBillingInfo:boolean;
  ShowShippingInfo:boolean;
  ShowAgentsInfo:boolean;
  ShowProfitSettings:boolean;
  ShowProcessingSettings:boolean;

  BrandFilter: {[k: string]: any} = {};
  Brands:any[];
  Brand:any;
  BrandSearchTerm:string;

  ImportConfigurations:any[];
  ConfigurationTerm:string;

  GroupTerm:string;

  ShowProductsProfits:boolean = false;
  ShowStockProductsProfits:boolean = true;

  ProductBoxStatuses:{[k: string]: any} = [];
  ProductConditionStatuses:{[k: string]: any} = [];
  ProductManufacturingStatuses:{[k: string]: any} = [];
  ProductVersionStatuses:{[k: string]: any} = [];
  WeightMeasurementTypes:{[k: string]: any} = [];
  LeadTimeTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesType:any;
  CombineWarehousesQuantityOnExport:boolean = true;
  Periods:any[];
  Languages:{[k: string]: any} = [];
  ExportLanguage:any;

  loadingProducts:boolean;

  ngOnInit(): void {
    this.InitializeFilter();
    this.InitializeBrandFilter();
    this.InitializePartnersFilter();
    this.GetMasterData();
    this.GetIndustryProductsMasterData();
    this.GetAllCompanies();
    this.GetProfitSettingsFilteredByChoice(1);
    this.InitializeBrandFilter();
    
    this.ShowBillingInfo = false;
    this.ShowShippingInfo = false;
    this.ShowAgentsInfo = false;
    this.ShowProfitSettings = true;
    this.ShowProcessingSettings = false;
  }

  ChangeStandardListPriceCurrency(c:any, p:any){
    
  }

  // Make sure your items and model share the same shape, e.g. { ID: number|string, Name: string, ... }
compareById = (a: any, b: any): boolean => !!a && !!b && a.ID === b.ID;

  InitializePartnersFilter(){
    this.PartnersFilter = {};
    this.PartnersFilter.SearchTerm = "";

    this.PartnersFilter.Pager = {};
    this.PartnersFilter.Pager.PageIndex = 1;
    this.PartnersFilter.Pager.PageSize = 250;
    this.PartnersFilter.Pager.TotalCount = 0;

    this.PartnersFilter.Company = {};
    this.PartnersFilter.Company = null;
    
    this.PartnersFilter.Country = {};
    this.PartnersFilter.Country = null;
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 50;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.GetPartnersFiltered();
    }
  }

  InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

  GetBrandsFiltered(searchTerm:string, page = 1){
    
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
        //  if(this.Brands.length == 1){
        //   this.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
        //   this.Brands = [];
        //   this.BrandFilter.SearchTerm = "";
        //   this.BrandSearchTerm = this.Brand.Name;
        //   this.Filter.Brand = this.Brand;
        //  }
        }
       });
  }

   ClearSearchBrand(){
    this.BrandFilter.SearchTerm = "";
    this.B2BAdminExportSettingsBrand = "";
    this.BrandSearchTerm = "";
    this.Brand = null;
    this.Brands = [];

    if(this.B2BAdminExportSettings?.Brand){
      this.B2BAdminExportSettings.Brand = {};
      this.B2BAdminExportSettings.Brand = null;
    }
   }

   ClearSearchPartners(){
    this.PartnersFilter.SearchTerm = "";
    this.PartnerSearchTerm = "";
    this.Partner = null;
    this.Partners = [];
   }

   ImportConfiguration:any;
   DiscountGroup:any;

   ClearSearchConfig(){
    this.ConfigurationTerm = "";
    this.ImportConfiguration = null;
    this.ImportConfigurations = [];
    this.Filter.ImportConfiguration = null;
   }
  
  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;
    
    this.Filter.Country = {};
    this.Filter.Country = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.Partner = {};
    this.Filter.Partner = null;

    this.Filter.ImportConfiguration = {};
    this.Filter.ImportConfiguration = null;

    this.Filter.DiscountGroup = {};
    this.Filter.DiscountGroup = null;

    this.Filter.Warehouse = {};
    this.Filter.Warehouse = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

    this.Brand = {};
    this.Brand = null;
    this.Partner = {};
    this.Partner = null;
    this.ImportConfiguration = {};
    this.ImportConfiguration = null;
    this.DiscountGroup = {};
    this.DiscountGroup = null;
    this.BrandSearchTerm = "";
    this.PartnerSearchTerm = "";
    this.ConfigurationTerm = "";
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.ShowFilter = false;
      // this.GetIndustryProductsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
    }
    else if(filterType == "ImportConfiguration"){
      this.Filter.ImportConfiguration = null;
    }
    else if(filterType == "DiscountGroup"){
      this.Filter.DiscountGroup = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "Warehouse"){
      this.Filter.Warehouse = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }
    else if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }

    // this.GetIndustryProductsFiltered();
  }

  GetMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Countries = response["Countries"];
        this.Banks = response["Banks"];
        this.AuxBanks = JSON.parse(JSON.stringify(this.Banks));
        this.ProfitSettingsPercentageImpacts = response["ProfitSettingsPercentageImpacts"];
      }
   
      this.parent.loading = false;
    });
  }

  GetIndustryProductsMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Periods = response["Periods"];
     this.Companies = response["Companies"];
     this.ProductBoxStatuses = response["ProductBoxStatuses"];
     this.ProductConditionStatuses = response["ProductConditionStatuses"];
     this.ProductManufacturingStatuses = response["ProductManufacturingStatuses"];
     this.ProductVersionStatuses = response["ProductVersionStatuses"];
     this.WeightMeasurementTypes = response["WeightMeasurementTypes"];
     this.LeadTimeTypes = response["LeadTimeTypes"];
     this.Currencies = response["Currencies"];
     this.ExportIndustryProductsStockValuesTypes = response["ExportIndustryProductsStockValuesTypes"];
     this.ExportIndustryProductsStockValuesType = this.ExportIndustryProductsStockValuesTypes[0];
     this.Languages = response["Languages"];
     this.ExportLanguage = this.Languages[0];

     this.Countries = response["Countries"];
    }
 
    this.parent.loading = false;
   });
   }

  GetAllCompanies(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetAllCompanies(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Companies = response["Companies"];
      }
   
      this.parent.loading = false;
    });
  }

  ProfitSettingsList:any[];
  loadingGallery:boolean = false;

  Products:any[];

  GetProfitSettingsFilteredByChoice(page = 1){

    // this.InitializeFilter();

    if(this.ShowProductsProfits == true){
      if(this.ShowStockProductsProfits == true){
        this.GetIndustryProductsStocksFiltered(page);
      }
      else{
        this.Products = null;
        this.Products = [];
        this.Products.length = 0;

        this.GetIndustryProductsListPriceFiltered(page);
      }
    }
    else{
      this.GetProfitSettingsFiltered(page);
    }
  }

  ResetPager(){
    this.Filter.Pager.PageIndex = 1;
  }

  GetIndustryProductsListPriceFiltered(page = 1){
    this.Filter.Pager.PageIndex = page;  
    
    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };

      this.loadingGallery = true;

      this.managementService.GetIndustryProductsListPriceFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         this.loadingGallery = false;
        }
        else if(response["Status"] == 1){
         this.Products = response["StockProducts"];
         this.loadingGallery = false;
        }
       });

       this.GetIndustryProductsListPriceFilteredCOUNT();
  }

  loadingGalleryCount:boolean = false;

  GetIndustryProductsListPriceFilteredCOUNT(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:JSON.parse(JSON.stringify(this.Filter))
    };

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.loadingGalleryCount = true;

    this.managementService.GetIndustryProductsListPriceFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       this.loadingGalleryCount = false;
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];
        this.loadingGalleryCount = false;
      }
     });
}

  GetIndustryProductsStocksFiltered(page = 1){
    this.Filter.Pager.PageIndex = page;  
    
    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };

      this.loadingGallery = true;

      this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Products = response["StockProducts"];
        }

        this.loadingGallery = false;
       });

       this.GetIndustryProductsStocksFilteredCOUNT();
  }

  GetIndustryProductsStocksFilteredCOUNT(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    this.loadingGallery = true;

    this.managementService.GetIndustryProductsStocksFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];
      }

      this.loadingGallery = false;

     });
}
  

  GetProfitSettingsFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;
    this.Filter.Brand = this.Brand;
    this.Filter.Partner = this.Partner;
    this.Filter.ImportConfiguration = this.ImportConfiguration;
    this.Filter.DiscountGroup = this.DiscountGroup;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };
    
    this.loadingGallery = true;

    this.managementService.GetProfitSettingsFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ProfitSettingsList = response["ProfitSettings"];
      }
      
      this.loadingGallery = false;
    });

    this.GetProfitSettingsFilteredCOUNT();
  }

  GetProfitSettingsFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    this.managementService.GetProfitSettingsFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];
      }
    });
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.PartnerSearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }

  ShowAddNewPartnerForm:boolean;

  InitializeNewPartnerForm(p:any){
    this.ShowAddNewPartnerForm = true;
    this.Partner = JSON.parse(JSON.stringify(p));
    this.CurrentBank = JSON.parse(JSON.stringify(this.Partner.Bank));
    this.Banks = JSON.parse(JSON.stringify(this.AuxBanks));
    this.CurrentShippingAddress = {};
    this.GetPartnerShippingAddresses(this.Partner.ID);

    this.ShowBillingInfo = true;
    this.ShowShippingInfo = false;
    this.ShowAgentsInfo = false;
    this.ShowProfitSettings = false;
    this.ShowProcessingSettings = false;
  }

  SwitchPartnerBank(b:any){
    if(b.ID == this.CurrentBank?.ID){
      this.Banks.forEach(bank => {
        if(bank.ID == this.CurrentBank?.ID){
          bank.BankAccount = this.CurrentBank?.BankAccount;
        }
      });
    }
  }

  GetPartnerEUData(partner:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.VAT,
      CountryCode:partner.BillingAddress.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){
        this.Partner.BillingAddress.Country = response["Country"];
        this.Partner.VAT = response["VAT"];
        this.Partner.EUVATVerified = response["EUVATVerified"];
        this.Partner.Name = response["Name"];
        this.Partner.BillingAddress.AddressLine = response["Address"];
      }
   
      this.parent.loading = false;
    });
  }

  GenerateInitialShippingAddress(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.Partner
    };

    this.parent.loading = true;
    this.service.GenerateInitialShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];

        var addressesLength = JSON.parse(JSON.stringify(this.Partner.ShippingAddresses?.length));

        if(addressesLength != null && addressesLength > 0){
          this.CurrentShippingAddress = this.Partner.ShippingAddresses[addressesLength - 1];
        }
      }
   
      this.parent.loading = false;
    });
  }

  AddUpdateShippingAddress(address:any, PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:address,
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.AddUpdateShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentShippingAddress = response["ShippingAddress"];

        if(this.CurrentShippingAddress.ID == 0){
          this.Partner.ShippingAddresses.push(this.CurrentShippingAddress);
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerShippingAddresses(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.GetPartnerShippingAddresses(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ShippingAddresses = response["ShippingAddresses"];
        this.CurrentShippingAddress = this.Partner.ShippingAddresses[0];
      }
   
      this.parent.loading = false;
    });
  }

  PartnerAgent:any;
  ShippingAddresses:any[];
  Departments:any[];
  ShowPartnerAddressDeleteMessage:boolean;
  PartnerAgents:any[];

  ShowPartnerAgentDeleteMessage:boolean;

  InitializePartnerAgent(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.InitializePartnerAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgent = response["PartnerAgent"];
        this.ShippingAddresses = response["ShippingAddresses"];
        this.Departments = response["Departments"];
      }
   
      this.parent.loading = false;
    });
  }

  DeletePartnerShippingAddress(shippingAddress:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:shippingAddress
    };

    this.parent.loading = true;
    this.service.DeletePartnerShippingAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ShippingAddresses = this.Partner.ShippingAddresses.filter(x => x.ID != shippingAddress.ID);
        this.CurrentShippingAddress = null;
      }
   
      this.parent.loading = false;
    });
  }

  AddUpdatePartnerAgent(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerAgent:this.PartnerAgent
    };

    this.parent.loading = true;
    this.service.AddUpdatePartnerAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgent = response["PartnerAgent"];
        this.PartnerAgents.push(this.PartnerAgent);
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerAgents(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.parent.loading = true;
    this.service.GetPartnerAgents(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgents = response["PartnerAgents"];
        this.ShippingAddresses = this.Partner.ShippingAddresses;
      }
   
      this.parent.loading = false;
    });
  }

  DeletePartnerAgent(AgentID:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AgentID:AgentID
    };

    this.parent.loading = true;
    this.service.DeletePartnerAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.PartnerAgents = this.PartnerAgents.filter(x => x.ID != AgentID);
        this.PartnerAgent = null;
      }
   
      this.parent.loading = false;
    });
  }

  AddNewPartner(partner:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:partner,
    };

    this.parent.loading = true;
    this.service.AddNewPartner(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var verifiedVAT = response["EUVATVerified"];
        this.Partner.EUVATVerified = verifiedVAT;
        this.Partner.TaxPayer = verifiedVAT;
        this.ShowAddNewPartnerForm = false;
        if(response["DuplicateDetected"]){
          this.Partner.ID = response["ID"];
          this.parent.openSnackBar(this.parent.translate.instant("Management.DuplicatePartnerDetected") + ": " + (response["Partner"]?.Name || ""), "OK", "alert-danger-snackbar");
        }
      }

      this.parent.loading = false;
    });
  }

  UpdatePartner(partner:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:partner,
    };

    this.parent.loading = true;
    this.service.UpdatePartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];
        this.ShowAddNewPartnerForm = false;
      }
   
      this.parent.loading = false;
    });
  }

  InitializeNewPartner(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;
    this.service.InitializeNewPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner = response["Partner"];
        this.ShowAddNewPartnerForm = true;
      }
   
      this.parent.loading = false;
    });
  }

  ShowNewProfitSettings:boolean = false;
  ProfitSettings:{[k: string]: any} = {};
  ShowDeleteProfitMessage:boolean = false;

  OpenNewProfitSettings(){

    this.GetBrandsFiltered("", 1);
  
    this.ProfitSettings = {
      ID:0,
      PartnerID:this.Partner?.ID,
      PartnerName:this.Partner?.Name,
      DiscountGroup:null,
      ImportConfiguration:null,
      Brand:this.Brand,
      Percentage:null,
      PercentageImpact:this.ProfitSettingsPercentageImpacts[0],
      ExtraAddedValue:null,
      ExtraAddedPercentageValue:null,
    };
  
    this.ConfigurationTerm = null;
    this.BrandSearchTerm = this.Brand?.Name;
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowNewProfitSettings = true;
      }
    
      this.parent.loading = false;
     });
  }

  GetImportConfigurations(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:this.ConfigurationTerm
    };
    
    this.parent.loading = true;
    
    this.managementService.GetImportConfigurations(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ImportConfigurations = response["ImportConfigurations"];
      }
    
      this.parent.loading = false;
     });
    }
  
  InitializeImportConfigurations(){
      if(this.ImportConfigurations == null || this.ImportConfigurations.length == 0){
        this.GetImportConfigurations();
      }
  }

  SelectConfiguration(c:any){
      this.ConfigurationTerm = c.Name;
      this.ImportConfiguration = c;
      this.Filter.ImportConfiguration = JSON.parse(JSON.stringify(c)); 
      this.GetImportConfigurationDetails(c);
  }

  GetPartnerProfitSettings(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.Partner.ID
    };
    
    this.parent.loading = true;
    
    this.service.GetPartnerProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.PartnerProfitSettings = response["PartnerProfitSettings"];
        this.Partner.PartnerProfitSettings = this.Partner.PartnerProfitSettings.filter(x => x.PartnerID == this.Partner.ID);
      }
    
      this.parent.loading = false;
     });
  }

  AddUpdatePartnerProfitSettings(){
  
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProfitSettings:this.ProfitSettings,
    };
    
    this.parent.loading = true;
    
    this.service.AddUpdatePartnerProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var ps = response["ProfitSettings"];
        this.ProfitSettings = JSON.parse(JSON.stringify(ps));
        
        const index = this.ProfitSettingsList.findIndex(x => x.ID === ps.ID);

        if (index !== -1) {
          this.ProfitSettingsList[index] = ps;
        }
        else{
          this.ProfitSettingsList.unshift(ps);
        }
      }
    
      this.ShowNewProfitSettings = false;
      this.parent.loading = false;
     });
  }

  CopyProfitSettingsUI(ps:any){
    this.EditProfitSettings(ps, true);
  }

  EditProfitSettings(ps:any, copy:boolean = false){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.OpenProfitSettings(ps, copy);
      }
    
      this.parent.loading = false;
     });
  }

  OpenProfitSettings(ps:any, copy:boolean = false){
    this.ShowNewProfitSettings = true;
    this.ProfitSettings = JSON.parse(JSON.stringify(ps));

    if(this.ProfitSettings?.ImportConfiguration != null){
      this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration, copy);
    }
  }

  GetImportConfigurationDetails(c:any, copy:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:c.ID
    };

    this.parent.loading = true;
    this.managementService.GetImportConfigurationDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ProfitSettings.ImportConfiguration = response["Configuration"];

        if(copy == true){
          this.ProfitSettings.ID = 0;
        }
      }
   
      this.parent.loading = false;
    });
  }

  DeleteProfitSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProfitSettings:this.ProfitSettings
    };
    
    this.parent.loading = true;
    
    this.service.DeleteProfitSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.ProfitSettingsList = this.ProfitSettingsList.filter(x => x.ID != this.ProfitSettings.ID);
        this.ProfitSettings = null;
        this.ProfitSettings = {};
      }
    
      this.ShowDeleteProfitMessage = false;
      this.ShowNewProfitSettings = false;
      this.parent.loading = false;
     });
  }

  CopyProfitSettings(ps:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
    this.parent.loading = true;
    
    this.service.CheckUserProfitRights(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.OpenProfitSettingsCopy(ps);
      }
    
      this.parent.loading = false;
     });
  }
    
  OpenProfitSettingsCopy(ps:any){
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.SearchTerm = "";
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };
  
      this.managementService.GetBrandsFiltered(request).subscribe(response => {
  
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
         this.ProfitSettings = JSON.parse(JSON.stringify(ps));
         this.ConfigurationTerm = this.ProfitSettings.ImportConfiguration?.Name;
         this.BrandSearchTerm = this.ProfitSettings.Brand?.Name;
  
         if(this.ProfitSettings.ImportConfiguration != null){
          this.GetImportConfigurationDetails(this.ProfitSettings.ImportConfiguration);
         }
  
         this.ProfitSettings.ID = 0;
         this.ProfitSettings.IsCopy = true;
        }
       });
  
    this.ShowNewProfitSettings = true;
  }

  GetPartnerProcessingSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Partner:this.Partner,
    };
    
    this.parent.loading = true;
    
    this.service.GetPartnerProcessingSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ProcessingSettings = response["ProcessingSettings"];
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
      }
    
      this.parent.loading = false;
     });
  }

  AddUpdatePartnerProcessingSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ProcessingSettings:this.Partner.ProcessingSettings,
    };
    
    this.parent.loading = true;
    
    this.service.AddUpdatePartnerProcessingSettings(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Partner.ProcessingSettings = response["ProcessingSettings"];
      }
    
      this.parent.loading = false;
     });
  }

  AddUpdateListPriceOffer(Offer:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:Offer,
    };
    
    this.parent.loading = true;
    
    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
    
      this.parent.loading = false;
     });
  }

  UpdateIndustryProduct(p:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:p,
      IgnoreDupplicates:true,
      WithListPriceOffers:true,
    };
    
    this.parent.loading = true;
    
    this.managementService.UpdateIndustryProduct(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
    
      this.parent.loading = false;
     });
  }

  ProfitSettingList:any[];

  ClearPartnerFromProfitSettings(){
    this.ProfitSettings.PartnerID = null;
    this.ProfitSettings.PartnerName = null;

    this.B2BAdminExportSettingsPartner = null;
   
    if(this.B2BAdminExportSettings?.Partner){
      this.B2BAdminExportSettings.Partner = {};
      this.B2BAdminExportSettings.Partner = null;
    }

    this.Partner = null;
  }

  B2BAdminExportSettings: {[k: string]: any} = {};
  ShowB2BAdminExportSettingsPop:boolean = false;
  B2BAdminExportSettingsPartner:string;
  B2BAdminExportSettingsBrand:string

  OpenNewExportSettings(){
    this.B2BAdminExportSettings.UIID = this.parent.newGuid();
    this.B2BAdminExportSettings.Partner = {};
    this.B2BAdminExportSettings.Partner = null;

    this.B2BAdminExportSettings.Brand = {};
    this.B2BAdminExportSettings.Brand = null;

    // ✅ Preselect the first PriceListExportType
    if (this.parent.CartMasterData?.PriceListExportTypes?.length > 0) {
      this.B2BAdminExportSettings.ExportType = this.parent.CartMasterData.PriceListExportTypes[0];
    }

    this.ShowB2BAdminExportSettingsPop = true;
  }

  ExportPriceList(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      B2BAdminExportSettings:this.B2BAdminExportSettings,
    };
    
    this.parent.loading = true;
    
    this.managementService.ExportPriceList(request).subscribe(response => {
    
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"]
        this.downloadExcel(Document.Name, Document.PDFStream);
      }
    
      this.parent.loading = false;
     });
  }
  
  // More specific version with error handling
  downloadExcel = (filename: string, base64Data: string): boolean => {
    try {
      // Validate inputs
      if (!filename || !base64Data) {
        console.error('Filename and base64 data are required');
        return false;
      }
      
      // Ensure filename has .xlsx extension
      const finalFilename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
      
      const element = document.createElement('a');
      const dataUrl = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;
      
      element.href = dataUrl;
      element.download = finalFilename;
      element.style.display = 'none';
      
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      
      return true;
    } catch (error) {
      console.error('Download failed:', error);
      return false;
    }
  };
   
}
